import request from '@/utils/httpRequest'

// 获取评论分页列表
export function getCommentList (params) {
  return request({
    url: `/activity/comment/list`,
    method: 'get',
    params
  })
}
// 获取活动评论回复详情
export function getCommentDetail (params) {
  return request({
    url: `/activity/comment/detail`,
    method: 'get',
    params
  })
}
// 删除活动评论回复
export function deleteCommentReply (data) {
  return request({
    url: `/activity/comment/delete_comment_reply`,
    method: 'post',
    data
  })
}

// 删除活动评论
export function deleteComment (data) {
  return request({
    url: `/activity/comment/delete_comment`,
    method: 'post',
    data
  })
}
